import { render, staticRenderFns } from "./logReiDtl.vue?vue&type=template&id=b68b5ef4&scoped=true&"
import script from "./logReiDtl.vue?vue&type=script&lang=js&"
export * from "./logReiDtl.vue?vue&type=script&lang=js&"
import style0 from "./logReiDtl.vue?vue&type=style&index=0&id=b68b5ef4&prod&lang=scss&scoped=true&"
import style1 from "./logReiDtl.vue?vue&type=style&index=1&id=b68b5ef4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68b5ef4",
  null
  
)

export default component.exports